import { useState } from 'react';

export const useConfirmation = () => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    title: '',
    message: '',
    confirmText: 'Confirmar',
    cancelText: 'Cancelar',
    type: 'warning',
    icon: '',
    onConfirm: null
  });

  const confirm = (options) => {
    return new Promise((resolve) => {
      setModalState({
        isOpen: true,
        title: options.title || 'Confirmar ação',
        message: options.message || 'Tem certeza que deseja realizar esta ação?',
        confirmText: options.confirmText || 'Confirmar',
        cancelText: options.cancelText || 'Cancelar',
        type: options.type || 'warning',
        icon: options.icon || '',
        onConfirm: () => {
          setModalState(prev => ({ ...prev, isOpen: false }));
          resolve(true);
        }
      });
    });
  };

  const close = () => {
    setModalState(prev => ({ ...prev, isOpen: false }));
  };

  return {
    modalState,
    confirm,
    close
  };
};

export const usePrompt = () => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    title: '',
    message: '',
    placeholder: '',
    confirmText: 'Confirmar',
    cancelText: 'Cancelar',
    type: 'text',
    required: false,
    icon: '',
    onConfirm: null
  });

  const prompt = (options) => {
    return new Promise((resolve) => {
      setModalState({
        isOpen: true,
        title: options.title || 'Digite a informação',
        message: options.message || '',
        placeholder: options.placeholder || '',
        confirmText: options.confirmText || 'Confirmar',
        cancelText: options.cancelText || 'Cancelar',
        type: options.type || 'text',
        required: options.required || false,
        icon: options.icon || '',
        onConfirm: (value) => {
          setModalState(prev => ({ ...prev, isOpen: false }));
          resolve(value);
        }
      });
    });
  };

  const close = () => {
    setModalState(prev => ({ ...prev, isOpen: false }));
  };

  return {
    modalState,
    prompt,
    close
  };
};